import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

import { legacySiteId, type LegacySiteId } from './LegacySite.js'
import { projectId, type ProjectId } from './Project.js'
import { userId, type UserId } from './User.js'

/** Identifier type for public.user_favorite_ */
export type UserFavoriteId = number & { __brand: 'UserFavoriteId' }

/** Represents the table public.user_favorite_ */
export default interface UserFavoriteTable {
  /** Database type: pg_catalog.int4 */
  id: ColumnType<UserFavoriteId, UserFavoriteId | undefined, UserFavoriteId>

  /** Database type: pg_catalog.uuid */
  userId: ColumnType<UserId, UserId, UserId>

  /** Database type: pg_catalog.int4 */
  siteId: ColumnType<
    LegacySiteId | null,
    LegacySiteId | null,
    LegacySiteId | null
  >

  /** Database type: pg_catalog.int4 */
  projectId: ColumnType<ProjectId | null, ProjectId | null, ProjectId | null>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date | null, Date | string | null, Date | string | null>
}

export type UserFavorite = Selectable<UserFavoriteTable>

export type UserFavoriteInitializer = Insertable<UserFavoriteTable>

export type UserFavoriteMutator = Updateable<UserFavoriteTable>

export const userFavoriteId = z.number() as unknown as z.Schema<UserFavoriteId>

export const userFavorite = z.object({
  id: userFavoriteId,
  userId: userId,
  siteId: legacySiteId.nullable().optional(),
  projectId: projectId.nullable().optional(),
  createdAt: z.coerce.date().nullable().optional(),
}) as unknown as z.Schema<UserFavorite>

export const userFavoriteInitializer = z.object({
  id: userFavoriteId.optional(),
  userId: userId,
  siteId: legacySiteId.optional().nullable(),
  projectId: projectId.optional().nullable(),
  createdAt: z.coerce.date().optional().nullable(),
}) as unknown as z.Schema<UserFavoriteInitializer>

export const userFavoriteMutator = z.object({
  id: userFavoriteId.optional(),
  userId: userId.optional(),
  siteId: legacySiteId.optional().nullable(),
  projectId: projectId.optional().nullable(),
  createdAt: z.coerce.date().optional().nullable(),
}) as unknown as z.Schema<UserFavoriteMutator>
